import { accessRole } from "../../../helpers/access_role"
import Shimmer from "react-shimmer-effect";

import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import {
  Card,
  Collapse, Media, Tooltip
} from "reactstrap"

import {
  apiRequest as baseApi,
  empSideMenuList as baseMenuList
} from "../../../services/adapters/base"

const PegawaiSideBar = (props) => {

  const [isOpen, setIsOpen] = useState(true);
  let [menuData, setMenuData] = useState(sessionStorage.getItem('kepegawaianSideMenu'));
  const [ttop, setttop] = useState(false)

  const toggle = (e) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  };

  useEffect(() => {
    setTimeout(() => {
      setMenuData(sessionStorage.getItem('kepegawaianSideMenu'));
    }, 500)

    loadData();
  }, [menuData]);

  let userdata = JSON.parse(localStorage.getItem('userdata'));
  let employeeSelected = JSON.parse(localStorage.getItem('employeeSelected'));

  // Load Kepegawaian SideMenu Data and Save to SessionStorage
  let peg_uuid = userdata != null ? userdata.employee_uuid : "";
  let employee_name = userdata != null ? userdata.employee_full_name : "";
  let employee_current_position_name = userdata != null ? userdata.employee_current_position_name : "";
  if(accessRole('approve')){
      peg_uuid = employeeSelected != null ? employeeSelected.employee_uuid : "";
      employee_name = employeeSelected != null ? (employeeSelected.hasOwnProperty('employee_full_name') ? employeeSelected.employee_full_name : employeeSelected.employee_name) : "";
      employee_current_position_name = employeeSelected != null ? employeeSelected.employee_current_position_name : "";
  }
  const loadData = async () => {
    await baseApi("get", baseMenuList, { params: {uuid: peg_uuid}, body: null, cancelToken: null })
      .then(result => {
        if (result.status) {
          const response = result.response
          sessionStorage.setItem('kepegawaianSideMenu', JSON.stringify(response))
          setMenuData(sessionStorage.getItem('kepegawaianSideMenu'));
        }
      })
  }

  const Menus = (props) => {
      let menus = JSON.parse(menuData);
      return (
          <>
              {
                  menus?.map((menu, i) => {
                      
                      const isHaveChild = (menu.childs.length > 0);
                      const linkMenu = isHaveChild ? '/' : `?${menu.side_employee_menu_url}`
                      const menuName = menu.side_employee_menu_name;
                      const IsActive = menu.side_employee_menu_url;
                      const notif = menu.notif;
                  
                      return (
                          isHaveChild ?
                            <MenuParent menu={menu} name={menuName} active={props.active} parentNotif={notif} />
                          :

                          <Link className={props.active===IsActive ? "active p-0 text-truncate" : "p-0 text-truncate"} to={linkMenu} key={`peg-m-${i}`}>
                            <i className="mdi mdi-chevron-right font-size-16 align-middle me-2"></i>{menuName} {' '}
                            { notif > 0 ? 
                              <label className="badge rounded-pill bg-soft-warning font-size-12" >{notif}</label>
                              : ''
                            }
                          </Link>
                      )
                  })
              }
          </>
      )
  }

  return (
    <React.Fragment>
      <Card className="pegawai-leftbar">
        <div className="d-flex">
            <img
              className="d-flex me-3 rounded-circle"
              src={'/static/media/avatar_male.887dda37.png'}
              alt=""
              height="36"
            />
            <Media className="chat-user-box overflow-hidden flex-1" body>
              <p className="user-title m-0">{employee_name}</p>
              <p className="text-muted text-truncate" id="TooltipTop">{employee_current_position_name ?? '-'}</p>
              <Tooltip
                placement="right"
                isOpen={ttop}
                target="TooltipTop"
                toggle={() => {
                  setttop(!ttop)
                }}
              >
                {employee_current_position_name ?? '-'}
              </Tooltip>
            </Media>
        </div>
        <hr className="mt-0" />
        <h6>Data Pegawai</h6>
        <div className="mail-list">
          {
            menuData == null ? <Shimmer><div style={{width: 100, height: 15}}></div></Shimmer> : <Menus active={props.active} />
          }
        </div>
      </Card>
    </React.Fragment>
  )
}

const MenuParent = (props) => {
  const { menu, name, active, parentNotif } = props;
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    let obj = menu.childs?.find(o => o.side_employee_menu_url === active)
    if(obj) { 
      setIsOpen(true)
    }
  }, [])
  
  const toggle = (e) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  };


  return (
    <div className="custom-accordion mb-0 p-0">
      <Link to="#" className="fw-semibold p-0 d-block" onClick={ e => toggle(e) }><i className="mdi mdi-chevron-down font-size-16 align-middle me-2"></i>{name} {' '}
        { parentNotif > 0 &&
          <label className="badge rounded-pill bg-soft-warning font-size-12" >{parentNotif}</label>
        }
      </Link>
      <Collapse isOpen={isOpen} className="mb-0">
           <div className="card p-0 shadow-none mb-0">
             <ul className="list-unstyled categories-list mb-0">
                {
                 menu.childs?.map((childMenu, j) => {
                   const childLinkMenu = `?${childMenu.side_employee_menu_url}`;
                   const childMenuName = childMenu.side_employee_menu_name;
                   const childIsActive = childMenu.side_employee_menu_url;
                   const childNotif = childMenu.notif;

                   return(
                     <li className={active===childIsActive ? "active p-0 text-truncate" : "p-0 text-truncate"} key={`peg-mc-${j}`}>
                       <Link to={childLinkMenu} className="py-0">
                         <i className="mdi mdi-chevron-right me-1"></i> {childMenuName} {' '}
                          { childNotif > 0 ? 
                              <label className="badge rounded-pill bg-soft-warning font-size-12" >{childNotif}</label>
                            : ''
                          }
                       </Link>
                     </li>
                   )
                 })
               }

             </ul>
           </div>
      </Collapse>
    </div>
  )
}

export default PegawaiSideBar